import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {Link} from "react-router-dom";
import {EditTopic} from "./EditTopic";

export const CreateTopicPage = (props: RouteComponentProps<{ language: string, stage: string }>) => {
    return <div className={'index-wrapper'}>
        <div className={'index-page'}>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                    <li className="breadcrumb-item"><Link to={`/courses/${props.match.params.language}`}>Courses</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Create Topic
                    </li>
                </ol>
            </nav>

            <h2 className={'col-12 mt-2 mb-5'}>Create topic</h2>

            <EditTopic stageId={Number(props.match.params.stage)} />
        </div>
    </div>
};
